export enum InteractionType {
  Drawing = 'drawing',
  GraphicHotspot = 'graphicHotspot',
  InlineChoice = 'inlineChoice',
  MultipleChoiceMatrix = 'multipleChoiceMatrix',
  MultipleSelect = 'multipleSelect',
  OpenQuestion = 'openQuestion',
  PerformQuestion = 'perform',
  SingleChoiceMatrix = 'singleChoiceMatrix',
  SingleSelect = 'singleSelect',
  TextEntry = 'textEntry',
  Highlight = 'highlight',
}

export const OPEN_INTERACTION_TYPES = [
  InteractionType.TextEntry,
  InteractionType.OpenQuestion,
  InteractionType.Drawing,
];
